import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './core/models/app-config';
import { map, mapTo, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ApiEndpointConfig } from 'src/environments/environment.interface';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private configuration: AppConfig = {};

  constructor(private httpClient: HttpClient) {}

  load(): Observable<void> {
    return this.httpClient.get('/assets/app.config.json').pipe(
      map((configuration: any) => (this.configuration = configuration || {})),
      mapTo(undefined),
    );
  }

  getValue(key: string, defaultValue?: any): any {
    type ObjectKey = keyof typeof this.configuration;
    const keyToGet = key as ObjectKey;
    return this.configuration[keyToGet] || defaultValue;
  }

  public getApiEndpoint(alias: string): string {
    const endpoints = environment.apiEnpoints as Record<string, ApiEndpointConfig>;
    const url = endpoints[alias].baseUrl;
    if (!url) {
      console.error(`[AppConfigService] No API URL configured for alias: ${alias}`);
    }
    return url;
  }

  public getApiConfig(alias: string): ApiEndpointConfig {
    const endpoints = environment.apiEnpoints as Record<string, ApiEndpointConfig>;
    const config = endpoints[alias];
    if (!config) {
      console.error(`[AppConfigService] No API configuration found for alias: ${alias}`);
    }
    return config;
  }

  public resolveApiName(url: string): string | null {
    const entries = Object.entries(environment.apiEnpoints);

    for (const [apiName, config] of entries) {
      if (url.startsWith(config.baseUrl)) {
        return apiName;
      }
    }

    return null;
  }
}
